import { useQuery } from '@apollo/client';
import React, { createContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import Loader from 'atoms/Loader/Loader';
import { fetchUserUnreadCounts } from 'store/inboxSlice';
import { fetchCurrentTennant, fetchUserProfile } from 'store/userSlice';
export const TenantContext = createContext({});
function OrganizationAccessRoute({ children }) {
    var _a;
    const dispatch = useDispatch();
    const { data, error, loading } = useQuery(GET_CURRENT_TENANT, {
        fetchPolicy: 'network-only',
    });
    useEffect(() => {
        dispatch(fetchUserProfile());
        dispatch(fetchCurrentTennant());
        // Fetch unread counts immediately after user authentication
        dispatch(fetchUserUnreadCounts());
    }, [dispatch]);
    if (loading) {
        return React.createElement(Loader, { fullViewport: true });
    }
    if ((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.currentTenant) {
        return React.createElement(TenantContext.Provider, { value: data }, children);
    }
    if (error) {
        return React.createElement(Redirect, { to: "/login" });
    }
    return React.createElement(Redirect, { to: "/no-organization" });
}
export default OrganizationAccessRoute;
